import PropTypes from "prop-types";
import React from "react";
import { icon } from "redux-store/applications/selectors";
import { IconCheckbox } from "ui/checkbox/icon";

class AppCheckboxGroup extends React.Component {
  static get propTypes() {
    return {
      apps: PropTypes.array.isRequired,
      onChange: PropTypes.func.isRequired,
      selectedApps: PropTypes.instanceOf(Set),
    };
  }

  render() {
    const { apps, onChange, selectedApps } = this.props;

    return (
      <div>
        {apps.map((app) => {
          return (
            <IconCheckbox
              key={app.id}
              checked={selectedApps.has(app.id)}
              icon={icon(app)}
              itemId={app.id}
              label={app.display_name}
              onChange={onChange}
              title={app.display_name}
            />
          );
        })}
      </div>
    );
  }
}

export { AppCheckboxGroup };
